import React from 'react';

// Brand mark loader — 4 path-y zhodné s logo/todue-mark.svg, len pohybový jazyk
// sa mení podľa variantu. Farby idú cez CSS premenné, takže fungujú v light/dark.
// Pulse poradie je clockwise: TL (modrá) → TR (žltá) → BR (červená) → BL (zelená).
const PIECES = [
  { fill: 'var(--brand-blue)',   corner: 'tl',
    d: 'M391.09,16.05h11.46V4.55h-14.38c-4.76,0-8.62,3.86-8.62,8.62v14.38h11.54v-11.5Z' },
  { fill: 'var(--brand-yellow)', corner: 'tr',
    d: 'M402.55,4.55v11.5h11.54v11.5h11.46v-14.38c0-4.76-3.86-8.62-8.62-8.62h-14.38Z' },
  { fill: 'var(--brand-green)',  corner: 'bl',
    d: 'M391.09,39.05v-11.5h-11.54v14.38c0,4.76,3.86,8.62,8.62,8.62h14.38v-11.5h-11.46Z' },
  { fill: 'var(--brand-red)',    corner: 'br',
    d: 'M414.09,39.05h-11.54v11.5h14.38c4.76,0,8.62-3.86,8.62-8.62v-14.38h-11.46v11.5Z' },
];

const PULSE_DELAY = { tl: '0s', tr: '0.2s', br: '0.4s', bl: '0.6s' };

export default function MarkLoader({
  variant = 'pulse',
  size = 48,
  className = '',
  label = 'Načítavam',
  ...rest
}) {
  const classes = `mark-loader mark-loader--${variant}${className ? ' ' + className : ''}`;
  return (
    <svg
      className={classes}
      width={size}
      height={size}
      viewBox="0 0 47 46"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
      {...rest}
    >
      <g transform="translate(-379 -4)">
        {PIECES.map((p) => {
          const style = variant === 'pulse' ? { animationDelay: PULSE_DELAY[p.corner] } : undefined;
          return (
            <path
              key={p.corner}
              fill={p.fill}
              d={p.d}
              className={`mark-loader__piece mark-loader__piece--${p.corner}`}
              style={style}
            />
          );
        })}
      </g>
    </svg>
  );
}
